export const errorPageHeader = {
  400: 'Hmm...',
  404: 'Hmm...',
  500: 'Hmm...',
  503: 'Under Maintenance',
};

export const errorPageCopy = {
  400: "We couldn't handle this page. Are you sure you're in the right place...? Meanwhile, we're still selling the healthiest pet food on the market!",
  404: "We couldn't find your page. But we're still selling the healthiest pet food on the market!",
  500: "We're working to figure out what happened... Meanwhile, we're still selling the healthiest pet food in the market!",
  503: "We're currently undergoing scheduled maintenance. Please check back later or contact customer experience at 844-88-OLLIE (65543).",
};
